import type { NullableMetafield, VariantDot } from '@velasca/types'
import { parseJSONSafe } from './parseJSONSafe'

interface VariantDotParams {
  variantColors: NullableMetafield
  soleColorHex: NullableMetafield
  variantColorStyle: NullableMetafield
  textureImageName: NullableMetafield
  variantImage: NullableMetafield
  imageAssetPublicPath: string
}

/**
 * It should return a variant dot with its fundamental properties.
 *
 */
export const getVariantDot = ({
  variantColors,
  soleColorHex,
  variantColorStyle,
  textureImageName,
  variantImage,
  imageAssetPublicPath,
}: VariantDotParams): VariantDot => {
  return {
    colors: variantColors?.value ? parseJSONSafe(variantColors.value) : [],
    sole: soleColorHex?.value ?? null,
    pattern: variantColorStyle?.value ?? null,
    texture:
      textureImageName?.value && imageAssetPublicPath
        ? `${imageAssetPublicPath}${textureImageName.value}`
        : null,
    img:
      variantImage?.value && imageAssetPublicPath
        ? `${imageAssetPublicPath}${variantImage.value}`
        : null,
  }
}
